export enum StateFavorite {
  ADD = 'add',
  DELETE = 'delete',
}

export interface IDescription {
  value: number;
  name: string;
}

export interface IcontextMenuItems {
  key?: string;
  text: string;
  onClick?: (event: MouseEvent) => void;
}

export interface ILookup {
  Value: string;
  Name: string;
}

export interface Persons {
  Id: string;
  FirstName: string;
  LastName: string;
  AddressPerson: { Position: string }[];
}

export interface StuffMemberPerson {
  Id: string;
  FirstName: string;
  LastName: string;
  Position: string;
}